@if (filtersKeys.length) {
  <div class="reset-filters-wrapper d-flex align-items-baseline justify-content-lg-start justify-content-between" >
    <span class="d-none d-lg-block" translate>Filter Results By</span>
    <div class="d-inline-flex flex-wrap">
      @for (filterName of filtersKeys; track filterName) {
        <div>
          @for (filter of filters[filterName]; track filter) {
            <div class="badge-outline d-inline-flex align-items-center">
              <button (click)="reset(filterName, filter)"
                [attr.aria-label]="('Remove' | translate) + ' ' + filter + ' ' + ('Filter' | translate)"
                class="btn p-0">
                <i class="ion-icon ion-ios-close-empty d-none d-lg-inline-block"></i>
                <i class="fa fa-times-circle d-lg-none align-middle"></i>
              </button>&nbsp;
              @if (filter !== 'true' && filter !== '1') {
                <span translate>{{filter}}</span>
              }
              @if (filter == 'true' || filter == '1') {
                <span  translate>{{filterName}}</span>
              }
            </div>
          }
        </div>
      }
    </div>
    <button class="btn btn-sm btn-link" (click)="resetAll($event)" translate>Reset Filters</button>
  </div>
}
